import AccessCode from './AccessCode';

export default AccessCode;
